import { observer } from "mobx-react";
import * as React from "react";
import { Button, FormGroup, HTMLSelect, InputGroup, Tooltip } from "@blueprintjs/core";
import { observable } from "mobx";
import { MDBCol, MDBRow } from "mdbreact";
import { LoginStore } from "../../stores/login/LoginStore";
import { AppStore } from "../../stores/AppStore";
import { isValidPassword } from "../../utils";

@observer
export class CreateUsuarioPage extends React.Component<{}, {}>{

    obs = observable({
        formErrors: [] as any,
        valida_senha: "" as string,
        valida_email: "" as string,
        loading: false as boolean
    })

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        if (LoginStore.obs.pessoa_nome == "") {
            return AppStore.setLocation("/login")
        }
    }

    handleValid() {
        let err: any = {}

        if (LoginStore.obs.email == "") {
            err.email = "E-mail obrigatório!"
        } else {
            let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            if (!regex.test(LoginStore.obs.email)) {
                err.email = "E-mail inválido!"
            } else {
                if (this.obs.valida_email != "") {
                    if (this.obs.valida_email != LoginStore.obs.email) {
                        err.confirma_email = "E-mails divergentes!"
                    }
                }
            }
        }

        if (LoginStore.obs.senha == "") {
            err.senha = "Senha obrigatório!"
        } else {
            if (!isValidPassword(LoginStore.obs.senha)) {
                err.senha = "Senha inválida!"
            } else {
                if (this.obs.valida_senha != "") {
                    if (this.obs.valida_senha != LoginStore.obs.senha) {
                        err.confirma_senha = "Senhas divergentes!"
                    }
                }
            }
        }

        if (this.obs.valida_email == "") {
            err.valida_email = "E-mail obrigatório!"
        }

        if (this.obs.valida_senha == "") {
            err.valida_senha = "Senha obrigatório!"
        }

        this.obs.formErrors = err
        return Object.keys(err).length < 1;
    }

    async handleContinuar() {
        this.obs.loading = true

        let isValid = this.handleValid()

        let ipv4: string = ""

        await fetch('https://api.ipify.org?format=json')
            .then(response => response.json())
            .then(data => {
                ipv4 = data.ip;
            })
            .catch(error => ipv4 = "")

        if (isValid) {
            let params = {
                nome_completo: LoginStore.obs.pessoa_nome,
                cpf: LoginStore.obs.pessoa_cpf,
                conta_id: LoginStore.obs.conta_id,
                email: LoginStore.obs.email,
                confirma_email: this.obs.valida_email,
                senha: LoginStore.obs.senha,
                confirma_senha: this.obs.valida_senha,
                ipv4: ipv4
            }
            let resp = await LoginStore.handleCreateuser(params)

            if (resp.ok) {
                this.obs.loading = false
                AppStore.setLocation("/conta/autenticar");
            } else {
                this.obs.formErrors.back_error = resp.error
            }
        }
        this.obs.loading = false
    }

    isValidLength() {
        let length = /^.{6,}$/

        if (length.test(LoginStore.obs.senha)) {
            return <img src="/images/checked.png" width="12px" />
        } else {
            return <img src="/images/cancel.svg" width="12px" />
        }
    }

    isValidMaisculo() {
        let main = /[A-Z]/

        if (main.test(LoginStore.obs.senha)) {
            return <img src="/images/checked.png" width="12px" />
        } else {
            return <img src="/images/cancel.svg" width="12px" />
        }
    }

    isValidMinusculo() {
        let min = /[a-z]/

        if (min.test(LoginStore.obs.senha)) {
            return <img src="/images/checked.png" width="12px" />
        } else {
            return <img src="/images/cancel.svg" width="12px" />
        }
    }

    isValidNumber() {
        let number = /\d/

        if (number.test(LoginStore.obs.senha)) {
            return <img src="/images/checked.png" width="12px" />
        } else {
            return <img src="/images/cancel.svg" width="12px" />
        }
    }

    isValidCaracter() {
        let caracter = /[!@#$%^&*()\-_+=\[{\]};:<>|./?]/

        if (caracter.test(LoginStore.obs.senha)) {
            return <img src="/images/checked.png" width="12px" />
        } else {
            return <img src="/images/cancel.svg" width="12px" />
        }
    }

    render() {

        return (
            <>
                <header className="header-create">
                    <img src="/images/logotipo_white.png" height="40" onClick={() => window.location.href = "/"} style={{ cursor: "pointer" }} />
                </header>
                <div className="page-cadastro">
                    <MDBRow>
                        <MDBCol md="12">
                            <h2 className="title-create-conta">Criar um usuário</h2>
                            <p style={{ fontSize: "16px" }}>Agora você criará os usuário principal para essa conta.</p>
                        </MDBCol>

                        <MDBCol md="6">
                            <h4 className="sub_title">Usuário principal (Dados de Login)
                                <br /><span className="non-valid">{this.obs.formErrors.back_error}</span>
                            </h4>
                            <FormGroup
                                className="form-group"
                                label="Nome Completo *">
                                <InputGroup type="text" value={LoginStore.obs.pessoa_nome} className="input-email" disabled />
                            </FormGroup>

                            <FormGroup
                                className="form-group"
                                label="CPF *">
                                <InputGroup type="text" value={LoginStore.obs.pessoa_cpf} className="input-email" disabled />
                            </FormGroup>

                            <FormGroup
                                className="form-group"
                                label="E-mail *">
                                <InputGroup type="text" name='new-email' autoComplete='new-email' onChange={(e: any) => LoginStore.obs.email = e.target.value} className="input-email" placeholder="email@email.com" />
                                <span className="non-valid">{this.obs.formErrors.email}</span>
                                <span className="non-valid">{this.obs.formErrors.confirma_email}</span>
                            </FormGroup>

                            <FormGroup
                                className="form-group"
                                label="Confirmar E-mail *">
                                <InputGroup type="text" name='new-confirm-email' autoComplete='new-confirm-email' onChange={(e: any) => this.obs.valida_email = e.target.value} className="input-email" placeholder="email@email.com" />
                                <span className="non-valid">{this.obs.formErrors.valida_email}</span>
                                <span className="non-valid">{this.obs.formErrors.confirma_email}</span>
                            </FormGroup>

                            <FormGroup
                                className="form-group"
                                label="Senha *"
                            >
                                <Tooltip position="right" content={
                                    <div>
                                        <p><b>Obrigatório:</b></p>

                                        <p>6 Caracteres {this.isValidLength()}</p>
                                        <p>1 Letra maiúscula {this.isValidMaisculo()} </p>
                                        <p>1 Letra minúscula {this.isValidMinusculo()} </p>
                                        <p>1 Número {this.isValidNumber()} </p>
                                        <p>1 Caractere especial {this.isValidCaracter()} </p>

                                    </div>
                                }>
                                    <InputGroup name='new-password' autoComplete='new-password' type="password" onChange={(e: any) => LoginStore.obs.senha = e.target.value} className="input-email" placeholder="***********" />
                                </Tooltip>
                                <span className="non-valid">{this.obs.formErrors.senha}</span>
                                <span className="non-valid">{this.obs.formErrors.confirma_senha}</span>
                            </FormGroup>

                            <FormGroup
                                className="form-group"
                                label="Confirmar a senha *">
                                <InputGroup type="password" name='new-confirm-email' autoComplete='new-confirm-email' onChange={(e: any) => this.obs.valida_senha = e.target.value} className="input-email" placeholder="***********" />
                                <span className="non-valid">{this.obs.formErrors.valida_senha}</span>
                                <span className="non-valid">{this.obs.formErrors.confirma_senha}</span>
                            </FormGroup>

                        </MDBCol>
                    </MDBRow>
                    <div className="submit-panel" style={{ marginBottom: "120px" }}>
                        {!this.obs.loading
                            ? <Button className="btn btn-submit submit-etapa" disabled={!LoginStore.obs.termos} onClick={() => this.handleContinuar()}>Continuar</Button>
                            : <Button className="btn btn-submit submit-etapa" disabled={!LoginStore.obs.termos}>
                                <i className="fa fa-spinner fa-spin"></i>
                                Carregando
                            </Button>
                        }

                        <h2 className="title-sec">
                            Na próxima etapa, você já poderá acessar o sistema.
                        </h2>
                    </div>
                </div>
            </>
        );
    }
}

export default CreateUsuarioPage;
